"use client";

// packages/react/dismissable-layer/src/DismissableLayer.tsx
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { composeEventHandlers } from "@radix-ui/primitive";
import { Primitive, dispatchDiscreteCustomEvent } from "@radix-ui/react-primitive";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useEscapeKeydown } from "@radix-ui/react-use-escape-keydown";
import { jsx } from "react/jsx-runtime";
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = /*#__PURE__*/React.createContext({
  layers: /* @__PURE__ */new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
  branches: /* @__PURE__ */new Set()
});
var DismissableLayer = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var _node$ownerDocument;
  var _props$disableOutside = props.disableOutsidePointerEvents,
    disableOutsidePointerEvents = _props$disableOutside === void 0 ? false : _props$disableOutside,
    onEscapeKeyDown = props.onEscapeKeyDown,
    onPointerDownOutside = props.onPointerDownOutside,
    onFocusOutside = props.onFocusOutside,
    onInteractOutside = props.onInteractOutside,
    onDismiss = props.onDismiss,
    layerProps = _objectWithoutProperties(props, _excluded);
  var context = React.useContext(DismissableLayerContext);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    node = _React$useState2[0],
    setNode = _React$useState2[1];
  var ownerDocument = (_node$ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var _React$useState3 = React.useState({}),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    force = _React$useState4[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node2) {
    return setNode(node2);
  });
  var layers = Array.from(context.layers);
  var _slice = _toConsumableArray(context.layersWithOutsidePointerEventsDisabled).slice(-1),
    _slice2 = _slicedToArray(_slice, 1),
    highestLayerWithOutsidePointerEventsDisabled = _slice2[0];
  var highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  var index = node ? layers.indexOf(node) : -1;
  var isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  var isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
  var pointerDownOutside = usePointerDownOutside(function (event) {
    var target = event.target;
    var isPointerDownOnBranch = _toConsumableArray(context.branches).some(function (branch) {
      return branch.contains(target);
    });
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  var focusOutside = useFocusOutside(function (event) {
    var target = event.target;
    var isFocusInBranch = _toConsumableArray(context.branches).some(function (branch) {
      return branch.contains(target);
    });
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  useEscapeKeydown(function (event) {
    var isHighestLayer = index === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  React.useEffect(function () {
    if (!node) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node);
    }
    context.layers.add(node);
    dispatchUpdate();
    return function () {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
        ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
      }
    };
  }, [node, ownerDocument, disableOutsidePointerEvents, context]);
  React.useEffect(function () {
    return function () {
      if (!node) return;
      context.layers.delete(node);
      context.layersWithOutsidePointerEventsDisabled.delete(node);
      dispatchUpdate();
    };
  }, [node, context]);
  React.useEffect(function () {
    var handleUpdate = function handleUpdate() {
      return force({});
    };
    document.addEventListener(CONTEXT_UPDATE, handleUpdate);
    return function () {
      return document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    };
  }, []);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, layerProps), {}, {
    ref: composedRefs,
    style: _objectSpread({
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0
    }, props.style),
    onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: composeEventHandlers(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  var context = React.useContext(DismissableLayerContext);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, ref);
  React.useEffect(function () {
    var node = ref.current;
    if (node) {
      context.branches.add(node);
      return function () {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, props), {}, {
    ref: composedRefs
  }));
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  var isPointerInsideReactTreeRef = React.useRef(false);
  var handleClickRef = React.useRef(function () {});
  React.useEffect(function () {
    var handlePointerDown = function handlePointerDown(event) {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        var handleAndDispatchPointerDownOutsideEvent2 = function handleAndDispatchPointerDownOutsideEvent2() {
          handleAndDispatchCustomEvent(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        var eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    var timerId = window.setTimeout(function () {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return function () {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: function onPointerDownCapture() {
      return isPointerInsideReactTreeRef.current = true;
    }
  };
}
function useFocusOutside(onFocusOutside) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var handleFocusOutside = useCallbackRef(onFocusOutside);
  var isFocusInsideReactTreeRef = React.useRef(false);
  React.useEffect(function () {
    var handleFocus = function handleFocus(event) {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        var eventDetail = {
          originalEvent: event
        };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return function () {
      return ownerDocument.removeEventListener("focusin", handleFocus);
    };
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: function onFocusCapture() {
      return isFocusInsideReactTreeRef.current = true;
    },
    onBlurCapture: function onBlurCapture() {
      return isFocusInsideReactTreeRef.current = false;
    }
  };
}
function dispatchUpdate() {
  var event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, _ref) {
  var discrete = _ref.discrete;
  var target = detail.originalEvent.target;
  var event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail: detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}
var Root = DismissableLayer;
var Branch = DismissableLayerBranch;
export { Branch, DismissableLayer, DismissableLayerBranch, Root };